import React, {useEffect, useState} from 'react';
import SubscriptionExpiredModal from 'src/pages/SubscriptionsPage/components/SubscriptionExpiredModal/SubscriptionExpiredModal';
import { useTranslation } from 'react-i18next';
import {useTypedSelector} from '../../hooks/useTypedSelector';
import selectors from '../../redux/selectors';
import {PAGES_ENUM} from '../../routes';

const SubscriptionExpired = () => {
    const subscriptionInfo = useTypedSelector(selectors.getSubscriptionInfo);
    const [isShowSubsExpPopup, setShowSubsExpPopup] = useState<boolean>(false);
    const { t: tSubscriptionsExpired } = useTranslation('translation', {
        keyPrefix: 'subscription-expired',
    });

    const onShowSubsExpPopupClose = () => {
        setShowSubsExpPopup(false);
    };

    useEffect(() => {
        if (window.location.pathname === PAGES_ENUM.HOME && subscriptionInfo?.subscriptionExpired) {
            setShowSubsExpPopup(true);
        }
    }, [subscriptionInfo]);

  return (
    <>
      <SubscriptionExpiredModal
        t={tSubscriptionsExpired}
        subscription={subscriptionInfo?.subscription}
        open={isShowSubsExpPopup}
        close={() => {
          onShowSubsExpPopupClose();
        }}
        title={tSubscriptionsExpired('modal-title')}
        isCanCloseModal={false}
        hideCloseIcon={true}
        expired={true}
      />
    </>
  );
};

export default SubscriptionExpired;
